import { AswerError } from '../../api/errors';
import { ResponseActionHandler } from '../../types/context';

// On a form submit ASWER error, focus the field named in
// error.focusField via the registered `setFocus` response action.
export const focusAswerErrorField = (
  error: unknown,
  getResponseActionHandler?: (name: string) => ResponseActionHandler | undefined
): void => {
  if (!(error instanceof AswerError) || !error.focusField) return;

  getResponseActionHandler?.('setFocus')?.(error.focusField);
};
